<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-cookie"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="modal-body-title">{{ lbl.cookie.title }}</div>
                    <div class="modal-body-txt">
                        {{ lbl.cookie.msg }}
                        <div class="modal-body-detail" @click="clickOpenDetail()">{{ lbl.cookie.detail }}</div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-wrapper" @click="clickOk()">
                        <div class="btn-txt">{{ lbl.cookie.btn }}</div>      
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {CookieModalController} controller (required) /components/Modal/Controller/CookieModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "CookieModal",
    props: {
        // busModal: Object,
        theme: String,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            tag: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickCancel: function() {
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickOpenDetail: function() {
            this.hide();
            this.controller.sendCallbackMoreDetail({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-cookie {
        @extend %modal-base;
        top: auto !important;
        height: auto !important;
        bottom: 0;

        .modal-body {
            padding: 10px 16px 24px 16px;
        }

        .modal-dialog {
            max-width: 100%;
            transition: none !important;
            padding: 0;

            .modal-content {
                border-radius: 16px 16px 0 0;
            }
        }

        .modal-base-body {

            .modal-body-title {
                color: $green-00987F;
                font-size: 1.75rem;
                font-family: $semi_bold;
                margin-bottom: 20px;
                text-align: center;
            }

            .modal-body-txt {
                color: $a-gray-575757;
                font-size: 1.5rem;
                font-family: $regular;
                line-height: normal !important;
                text-align: left !important;
            }

            .modal-body-detail {
                color: $green-00987F;
                text-decoration: underline;
            }
        }

        .modal-base-footer {
            margin-top: 16px;
        }
    }
</style>
